import cx from "classnames";
import { FC } from "react";

import { FiClock } from "react-icons/fi";
import { RiMailCloseLine } from "react-icons/ri";
import { BiCheckCircle } from "react-icons/bi";
import styles from "./style.module.scss";

type Status = "pending" | "accepted" | "not_accepted";
interface StateProps {
  label: string;
  status: Status;
}

const StatusTag: FC<StateProps> = ({ label, status }) => {
  status = status.toLowerCase() as Status;
  const style = styles[status];

  const getStatusIcon = (status: Status) => {
    return status === "accepted" ? (
      <BiCheckCircle size={23} />
    ) : status === "not_accepted" ? (
      <RiMailCloseLine size={20} />
    ) : (
      <FiClock size={20} />
    );
  };
  return (
    <>
      <span className={cx(style, "tag")}>
        {" "}
        {getStatusIcon(status)}&nbsp; {label}
      </span>
    </>
  );
};

export default StatusTag;
